import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

async function getData(actId) {
  return client.get(`/contracts/act/${actId}`)
}

const useAct = (actId, config) => {
  return useQuery({
    queryKey: ['contract', 'act', actId],
    queryFn: () => getData(actId),
    staleTime: 5 * 60000,
    ...config
  })
}

export default useAct
